/**
 * @generated SignedSource<<7722a0a292f1c0e3bcf8540fc3eafdac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4FilterActionsRefactored$data = {
  readonly __typename: string;
  readonly filterId: string;
  readonly id: string;
  readonly isEditable?: boolean | null;
  readonly isFavourite: boolean | null;
  readonly name: string;
  readonly owner?: {
    readonly accountId: string;
  } | null;
  readonly " $fragmentType": "Nav4FilterActionsRefactored";
};
export type Nav4FilterActionsRefactored$key = {
  readonly " $data"?: Nav4FilterActionsRefactored$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4FilterActionsRefactored">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Nav4FilterActionsRefactored",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "isFavourite"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "filterId"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        },
        {
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accountId"
            }
          ]
        }
      ],
      "type": "JiraCustomFilter"
    }
  ],
  "type": "JiraFilter",
  "abstractKey": "__isJiraFilter"
};

(node as any).hash = "cc403d3352895d01f0127d958555957e";

export default node;
